// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-bubble-comp {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 0px 16px;
  margin: 12px 0 8px 0px;
}
.agent-bubble-comp.if-animation-bubble {
  animation-name: bubbleAnim;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.agent-bubble-comp .agent-bubble-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  max-width: 100%;
  padding-left: 10%;
  transition: 0.5s all ease;
  word-break: break-word;
}
.agent-bubble-comp .agent-bubble-content:hover .bubble-msg-with-img .bubble-msg {
  background-color: var(--agent-bubble-msg-bg-hover);
}
.agent-bubble-comp .agent-bubble-content.if-agent-img {
  padding-right: 32px;
}
.agent-bubble-comp .agent-bubble-content.if-agent-img .bubble-msg-with-img .agent-img {
  display: block;
}
.agent-bubble-comp .agent-bubble-content.small_text .top-info .time-stamp {
  font-size: 10px;
  line-height: 12px;
}
.agent-bubble-comp .agent-bubble-content.small_text .top-info .time-stamp time {
  font-size: 10px;
}
.agent-bubble-comp .agent-bubble-content.small_text .top-info .you-text, .agent-bubble-comp .agent-bubble-content.small_text .top-info .copied-text {
  font-size: 10px;
  line-height: 12px;
}
.agent-bubble-comp .agent-bubble-content.small_text .bubble-msg-with-img .bubble-msg {
  font-size: 12px;
  line-height: 15px;
}
.agent-bubble-comp .agent-bubble-content.small_text .bottom-info .time-stamp {
  font-size: 10px;
  line-height: 12px;
}
.agent-bubble-comp .agent-bubble-content.small_text .bottom-info .time-stamp time {
  font-size: 10px;
}
.agent-bubble-comp .agent-bubble-content.small_text .bottom-info .you-text, .bot-bubble-comp .bot-bubble-content .top-info .agent-bubble-comp .agent-bubble-content.small_text .bottom-info .copied-text, .agent-bubble-comp .agent-bubble-content.small_text .bottom-info .top-info .copied-text, .agent-bubble-comp .agent-bubble-content.small_text .top-info .bottom-info .copied-text {
  font-size: 10px;
  line-height: 12px;
}
.agent-bubble-comp .agent-bubble-content.small_text .bottom-info .read-text {
  font-size: 10px;
  line-height: 12px;
}
.agent-bubble-comp .agent-bubble-content.large_text .top-info .time-stamp {
  font-size: 14px;
  line-height: 17px;
}
.agent-bubble-comp .agent-bubble-content.large_text .top-info .time-stamp time {
  font-size: 14px;
}
.agent-bubble-comp .agent-bubble-content.large_text .top-info .you-text, .agent-bubble-comp .agent-bubble-content.large_text .top-info .copied-text {
  font-size: 14px;
  line-height: 17px;
}
.agent-bubble-comp .agent-bubble-content.large_text .bubble-msg-with-img .bubble-msg {
  font-size: 16px;
  line-height: 19px;
}
.agent-bubble-comp .agent-bubble-content.large_text .bottom-info .time-stamp {
  font-size: 14px;
  line-height: 17px;
}
.agent-bubble-comp .agent-bubble-content.large_text .bottom-info .time-stamp time {
  font-size: 14px;
}
.agent-bubble-comp .agent-bubble-content.large_text .bottom-info .you-text, .bot-bubble-comp .bot-bubble-content .top-info .agent-bubble-comp .agent-bubble-content.large_text .bottom-info .copied-text, .agent-bubble-comp .agent-bubble-content.large_text .bottom-info .top-info .copied-text, .agent-bubble-comp .agent-bubble-content.large_text .top-info .bottom-info .copied-text {
  font-size: 10px;
  line-height: 12px;
}
.agent-bubble-comp .agent-bubble-content.large_text .bottom-info .read-text {
  font-size: 14px;
  line-height: 17px;
}
.agent-bubble-comp .agent-bubble-content.chat-bubble-style-1 .bubble-msg-with-img .bubble-msg {
  border-radius: 16px;
}
.agent-bubble-comp .agent-bubble-content.chat-bubble-style-2 .bubble-msg-with-img .bubble-msg {
  border-radius: 8px 2px 8px 8px;
}
.agent-bubble-comp .agent-bubble-content.hover-show-copy:hover .bubble-msg-with-img .copy-bubble {
  display: block;
}
.agent-bubble-comp .agent-bubble-content.time-stamp-show-hover .top-info .time-stamp {
  display: none;
}
.agent-bubble-comp .agent-bubble-content.time-stamp-show-hover .bottom-info .time-stamp {
  display: none;
}
.agent-bubble-comp .agent-bubble-content.time-stamp-show-hover:hover .top-info .time-stamp {
  display: block;
}
.agent-bubble-comp .agent-bubble-content.time-stamp-show-hover:hover .bottom-info .time-stamp {
  display: block;
}
.agent-bubble-comp .agent-bubble-content .top-info {
  display: flex;
  align-items: center;
  gap: 4px;
}
.agent-bubble-comp .agent-bubble-content .top-info .time-stamp {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--time-stamp-color);
}
.agent-bubble-comp .agent-bubble-content .top-info .time-stamp time {
  font-size: 12px;
}
.agent-bubble-comp .agent-bubble-content .top-info .you-text, .agent-bubble-comp .agent-bubble-content .top-info .copied-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--name-color);
}
.agent-bubble-comp .agent-bubble-content .bubble-msg-with-img {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  margin: 2px 0;
  position: relative;
}
.agent-bubble-comp .agent-bubble-content .bubble-msg-with-img .bubble-msg {
  background: var(--agent-bubble-msg-bg);
  border-radius: 8px 8px 2px 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--agent-bubble-msg-color);
  padding: 8px 12px;
  margin: 2px 0;
}
.agent-bubble-comp .agent-bubble-content .bubble-msg-with-img .copy-bubble {
  position: absolute;
  left: -24px;
  top: auto;
  z-index: 1;
  cursor: pointer;
  font-size: 14px;
  display: none;
}
.agent-bubble-comp .agent-bubble-content .bubble-msg-with-img .copy-bubble svg path {
  fill: var(--sdk-gloabl-text-color);
}
.agent-bubble-comp .agent-bubble-content .bubble-msg-with-img .agent-img {
  position: absolute;
  right: -32px;
  bottom: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  display: none;
}
.agent-bubble-comp .agent-bubble-content .bubble-msg-with-img .agent-img figure {
  line-height: normal;
  width: 100%;
  height: 100%;
}
.agent-bubble-comp .agent-bubble-content .bubble-msg-with-img .agent-img figure img {
  border: 1.5px solid var(--agent-bubble-img-border);
  border-radius: 100px;
  width: 100%;
  height: 100%;
}
.agent-bubble-comp .agent-bubble-content .bottom-info {
  display: flex;
  align-items: center;
  gap: 4px;
}
.agent-bubble-comp .agent-bubble-content .bottom-info .time-stamp {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--time-stamp-color);
}
.agent-bubble-comp .agent-bubble-content .bottom-info .time-stamp time {
  font-size: 12px;
}
.agent-bubble-comp .agent-bubble-content .bottom-info .you-text, .bot-bubble-comp .bot-bubble-content .top-info .agent-bubble-comp .agent-bubble-content .bottom-info .copied-text, .agent-bubble-comp .agent-bubble-content .bottom-info .top-info .copied-text, .agent-bubble-comp .agent-bubble-content .top-info .bottom-info .copied-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--name-color);
}
.agent-bubble-comp .agent-bubble-content .bottom-info .read-text {
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  color: var(--sdk-gloabl-text-color);
  display: flex;
  align-items: center;
}
.agent-bubble-comp .agent-bubble-content .bottom-info .read-text i {
  color: var(--agent-bubble-read-status-icon-color);
  font-size: 10px;
  margin-left: 5px;
}
.agent-bubble-comp .agent-bubble-content .bottom-info .read-text.hide {
  display: none;
}
.agent-bubble-comp .agent-bubble-content .bottom-info .errorMsg {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
}
.agent-bubble-comp .agent-bubble-content .bottom-info .errorMsg .failed-text {
  color: var(--destructive-500-main, #EF4444);
}
.agent-bubble-comp .agent-bubble-content .bottom-info .errorMsg .retry-text, .agent-bubble-comp .agent-bubble-content .bottom-info .errorMsg .delete-text {
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
  color: var(--sdk-global-theme-color);
}
.agent-bubble-comp .agent-bubble-content .bottom-info .errorMsg .or-text {
  opacity: 0.5;
  color: var(--sdk-gloabl-text-color);
}

.bot-bubble-comp {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  padding: 0px 16px;
  margin: 12px 0 8px 0;
}
.bot-bubble-comp.if-animation-bubble {
  animation-name: bubbleAnim;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.bot-bubble-comp .bot-bubble-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 100%;
  padding-left: 32px;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 10%;
  padding-left: 32px;
  transition: 0.5s all ease;
  word-break: break-word;
}
.bot-bubble-comp .bot-bubble-content:hover .bubble-msg-with-img .bubble-msg {
  background-color: var(--bot-bubble-msg-bg-hover);
}
.bot-bubble-comp .bot-bubble-content.small_text .top-info .time-stamp {
  font-size: 10px;
  line-height: 12px;
}
.bot-bubble-comp .bot-bubble-content.small_text .top-info .time-stamp time {
  font-size: 10px;
}
.bot-bubble-comp .bot-bubble-content.small_text .top-info .you-text, .bot-bubble-comp .bot-bubble-content.small_text .top-info .copied-text {
  font-size: 10px;
  line-height: 12px;
}
.bot-bubble-comp .bot-bubble-content.small_text .bubble-msg-with-img .bubble-msg {
  font-size: 12px;
  line-height: 15px;
}
.bot-bubble-comp .bot-bubble-content.small_text .bottom-info .time-stamp {
  font-size: 10px;
  line-height: 12px;
}
.bot-bubble-comp .bot-bubble-content.small_text .bottom-info .time-stamp time {
  font-size: 10px;
}
.bot-bubble-comp .bot-bubble-content.small_text .bottom-info .you-text, .bot-bubble-comp .bot-bubble-content.small_text .bottom-info .top-info .copied-text, .bot-bubble-comp .bot-bubble-content.small_text .top-info .bottom-info .copied-text, .agent-bubble-comp .agent-bubble-content .top-info .bot-bubble-comp .bot-bubble-content.small_text .bottom-info .copied-text {
  font-size: 10px;
  line-height: 12px;
}
.bot-bubble-comp .bot-bubble-content.small_text .bottom-info .read-text {
  font-size: 10px;
  line-height: 12px;
}
.bot-bubble-comp .bot-bubble-content.large_text .top-info .time-stamp {
  font-size: 14px;
  line-height: 17px;
}
.bot-bubble-comp .bot-bubble-content.large_text .top-info .time-stamp time {
  font-size: 14px;
}
.bot-bubble-comp .bot-bubble-content.large_text .top-info .you-text, .bot-bubble-comp .bot-bubble-content.large_text .top-info .copied-text {
  font-size: 14px;
  line-height: 17px;
}
.bot-bubble-comp .bot-bubble-content.large_text .bubble-msg-with-img .bubble-msg {
  font-size: 16px;
  line-height: 19px;
}
.bot-bubble-comp .bot-bubble-content.large_text .bottom-info .time-stamp {
  font-size: 14px;
  line-height: 17px;
}
.bot-bubble-comp .bot-bubble-content.large_text .bottom-info .time-stamp time {
  font-size: 14px;
}
.bot-bubble-comp .bot-bubble-content.large_text .bottom-info .you-text, .bot-bubble-comp .bot-bubble-content.large_text .bottom-info .top-info .copied-text, .bot-bubble-comp .bot-bubble-content.large_text .top-info .bottom-info .copied-text, .agent-bubble-comp .agent-bubble-content .top-info .bot-bubble-comp .bot-bubble-content.large_text .bottom-info .copied-text {
  font-size: 10px;
  line-height: 12px;
}
.bot-bubble-comp .bot-bubble-content.large_text .bottom-info .read-text {
  font-size: 14px;
  line-height: 17px;
}
.bot-bubble-comp .bot-bubble-content.chat-bubble-style-1 .bubble-msg-with-img .bubble-msg {
  border-radius: 16px;
}
.bot-bubble-comp .bot-bubble-content.chat-bubble-style-2 .bubble-msg-with-img .bubble-msg {
  border-radius: 2px 8px 8px 8px;
}
.bot-bubble-comp .bot-bubble-content.hover-show-copy:hover .bubble-msg-with-img .copy-bubble {
  display: block;
}
.bot-bubble-comp .bot-bubble-content.time-stamp-show-hover .top-info .time-stamp {
  display: none;
}
.bot-bubble-comp .bot-bubble-content.time-stamp-show-hover .bottom-info .time-stamp {
  display: none;
}
.bot-bubble-comp .bot-bubble-content.time-stamp-show-hover:hover .top-info .time-stamp {
  display: block;
}
.bot-bubble-comp .bot-bubble-content.time-stamp-show-hover:hover .bottom-info .time-stamp {
  display: block;
}
.bot-bubble-comp .bot-bubble-content .top-info {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.bot-bubble-comp .bot-bubble-content .top-info .time-stamp {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--time-stamp-color);
  flex-shrink: 0;
}
.bot-bubble-comp .bot-bubble-content .top-info .time-stamp time {
  font-size: 12px;
}
.bot-bubble-comp .bot-bubble-content .top-info .you-text, .bot-bubble-comp .bot-bubble-content .top-info .copied-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--name-color);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img {
  display: flex;
  align-items: flex-start;
  margin: 4px 0;
  position: relative;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .bubble-msg {
  background: var(--bot-bubble-msg-bg);
  border-radius: 8px 8px 8px 2px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--bot-bubble-msg-color);
  padding: 8px 12px;
  margin: 2px 0;
  word-break: break-word;
  white-space: break-spaces;
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .bubble-msg img {
  width: 100%;
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .bubble-msg p.indent {
  padding-left: 10px;
  margin: 0;
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .bubble-msg .isLink a {
  color: var(--sdk-global-theme-color);
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .copy-bubble {
  position: absolute;
  right: -24px;
  top: auto;
  z-index: 1;
  cursor: pointer;
  font-size: 14px;
  display: none;
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .copy-bubble svg path {
  fill: var(--sdk-gloabl-text-color);
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .bot-img {
  position: absolute;
  right: auto;
  left: -32px;
  top: 0;
  bottom: auto;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .bot-img figure {
  line-height: normal;
  width: 100%;
  height: 100%;
}
.bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .bot-img figure img {
  border: 1.5px solid var(--bot-bubble-img-border);
  border-radius: 100px;
  width: 100%;
  height: 100%;
}
.bot-bubble-comp .bot-bubble-content .bottom-info {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.bot-bubble-comp .bot-bubble-content .bottom-info .time-stamp {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--time-stamp-color);
  flex-shrink: 0;
}
.bot-bubble-comp .bot-bubble-content .bottom-info .time-stamp time {
  font-size: 12px;
}
.bot-bubble-comp .bot-bubble-content .bottom-info .you-text, .agent-bubble-comp .agent-bubble-content .top-info .bot-bubble-comp .bot-bubble-content .bottom-info .copied-text, .bot-bubble-comp .bot-bubble-content .bottom-info .top-info .copied-text, .bot-bubble-comp .bot-bubble-content .top-info .bottom-info .copied-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--name-color);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bot-bubble-comp .bot-bubble-content .bottom-info .read-text {
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  color: var(--sdk-gloabl-text-color);
  flex-shrink: 0;
}

.attachment-sended-temp-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 16px 5px 16px;
}
.attachment-sended-temp-wrapper .multiple-attchments {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchments-wrap {
  display: flex;
  gap: 4px;
  align-items: flex-start;
  position: relative;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchments-wrap .img-attch {
  width: 100%;
  height: 100%;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchments-wrap .img-attch figure {
  line-height: 0;
  width: 100%;
  height: 100%;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchments-wrap .img-attch figure img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchments-wrap .layer-multiple {
  position: absolute;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.4);
  width: 132px;
  height: 100px;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sdk-global-white);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
  z-index: 2;
  border: 0;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchment-details {
  display: flex;
  padding: 8px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchment-details .content-info {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchment-details .content-info h2 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchment-details .content-info p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin-top: 4px;
}
.attachment-sended-temp-wrapper .multiple-attchments .attchment-details .kr-button-blue-light {
  width: auto;
  flex-shrink: 0;
}

[dir=rtl] .bot-bubble-comp .bot-bubble-content {
  padding-left: 10%;
  padding-right: 32px;
}

.bot-bubble-comp .time-stamp,
.agent-bubble-comp .time-stamp {
  direction: ltr;
  unicode-bidi: isolate;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/message/message.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;AAAJ;AACI;EACI,0BAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;AACR;AACI;EACI,aAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;AACR;AAEgB;EACI,kDAAA;AAApB;AAIQ;EACI,mBAAA;AAFZ;AAIgB;EACI,cAAA;AAFpB;AAQgB;EACI,eAAA;EACA,iBAAA;AANpB;AAOoB;EACI,eAAA;AALxB;AAQgB;EACI,eAAA;EACA,iBAAA;AANpB;AAUgB;EACI,eAAA;EACA,iBAAA;AARpB;AAYgB;EACI,eAAA;EACA,iBAAA;AAVpB;AAWoB;EACI,eAAA;AATxB;AAYgB;EACI,eAAA;EACA,iBAAA;AAVpB;AAYgB;EACI,eAAA;EACA,iBAAA;AAVpB;AAgBgB;EACI,eAAA;EACA,iBAAA;AAdpB;AAeoB;EACI,eAAA;AAbxB;AAgBgB;EACI,eAAA;EACA,iBAAA;AAdpB;AAkBgB;EACI,eAAA;EACA,iBAAA;AAhBpB;AAoBgB;EACI,eAAA;EACA,iBAAA;AAlBpB;AAmBoB;EACI,eAAA;AAjBxB;AAoBgB;EACI,eAAA;EACA,iBAAA;AAlBpB;AAoBgB;EACI,eAAA;EACA,iBAAA;AAlBpB;AAwBgB;EACI,mBAAA;AAtBpB;AA4BgB;EACI,8BAAA;AA1BpB;AAiCoB;EACI,cAAA;AA/BxB;AAsCgB;EACI,aAAA;AApCpB;AAwCgB;EACI,aAAA;AAtCpB;AA2CoB;EACI,cAAA;AAzCxB;AA6CoB;EACI,cAAA;AA3CxB;AAgDQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AA9CZ;AA+CY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AA7ChB;AA8CgB;EACI,eAAA;AA5CpB;AA+CY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;AA7ChB;AAmDQ;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AAjDZ;AAkDY;EACI,sCAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,aAAA;AAhDhB;AAkDY;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;AAhDhB;AAkDoB;EACI,kCAAA;AAhDxB;AAoDY;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAlDhB;AAmDgB;EACI,mBAAA;EACA,WAAA;EACA,YAAA;AAjDpB;AAkDoB;EACI,kDAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AAhDxB;AAqDQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAnDZ;AAoDY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AAlDhB;AAmDgB;EACI,eAAA;AAjDpB;AAoDY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;AAlDhB;AAoDY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;AAlDhB;AAmDgB;EACI,iDAAA;EACA,eAAA;EACA,gBAAA;AAjDpB;AAmDgB;EACI,aAAA;AAjDpB;AAoDY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAlDhB;AAmDgB;EACI,2CAAA;AAjDpB;AAmDgB;EACG,uBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,oCAAA;AAjDnB;AAmDgB;EACI,YAAA;EACA,mCAAA;AAjDpB;;AAyDA;EACI,aAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,oBAAA;AAtDJ;AAuDI;EACI,0BAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;AArDR;AAuDI;EACI,aAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AArDR;AAwDgB;EACI,gDAAA;AAtDpB;AA4DgB;EACI,eAAA;EACA,iBAAA;AA1DpB;AA2DoB;EACI,eAAA;AAzDxB;AA4DgB;EACI,eAAA;EACA,iBAAA;AA1DpB;AA8DgB;EACI,eAAA;EACA,iBAAA;AA5DpB;AAgEgB;EACI,eAAA;EACA,iBAAA;AA9DpB;AA+DoB;EACI,eAAA;AA7DxB;AAgEgB;EACI,eAAA;EACA,iBAAA;AA9DpB;AAgEgB;EACI,eAAA;EACA,iBAAA;AA9DpB;AAoEgB;EACI,eAAA;EACA,iBAAA;AAlEpB;AAmEoB;EACI,eAAA;AAjExB;AAoEgB;EACI,eAAA;EACA,iBAAA;AAlEpB;AAsEgB;EACI,eAAA;EACA,iBAAA;AApEpB;AAwEgB;EACI,eAAA;EACA,iBAAA;AAtEpB;AAuEoB;EACI,eAAA;AArExB;AAwEgB;EACI,eAAA;EACA,iBAAA;AAtEpB;AAwEgB;EACI,eAAA;EACA,iBAAA;AAtEpB;AA4EgB;EACI,mBAAA;AA1EpB;AAgFgB;EACI,8BAAA;AA9EpB;AAqFoB;EACI,cAAA;AAnFxB;AA0FgB;EACI,aAAA;AAxFpB;AA4FgB;EACI,aAAA;AA1FpB;AA+FoB;EACI,cAAA;AA7FxB;AAiGoB;EACI,cAAA;AA/FxB;AAoGQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAlGZ;AAmGY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,cAAA;AAjGhB;AAkGgB;EACI,eAAA;AAhGpB;AAmGY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAjGhB;AAuGQ;EACI,aAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AArGZ;AAsGY;EACI,oCAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AApGhB;AAqGgB;EACI,WAAA;AAnGpB;AAqGgB;EACX,kBAAA;EACA,SAAA;AAnGL;AAsGoB;EACI,oCAAA;AApGxB;AAwGY;EACI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;AAtGhB;AAwGoB;EACI,kCAAA;AAtGxB;AA0GY;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxGhB;AAyGgB;EACI,mBAAA;EACA,WAAA;EACA,YAAA;AAvGpB;AAwGoB;EACI,gDAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AAtGxB;AA2GQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAzGZ;AA0GY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,cAAA;AAxGhB;AAyGgB;EACI,eAAA;AAvGpB;AA0GY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAxGhB;AA0GY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,cAAA;AAxGhB;;AA+GA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;AA5GJ;AA6GI;EACI,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,eAAA;AA5GR;AA6GQ;EACI,aAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;AA3GZ;AA4GY;EACI,WAAA;EACA,YAAA;AA1GhB;AA2GgB;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAzGpB;AA0GoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAxGxB;AA4GY;EACI,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AA1GhB;AA6GQ;EACI,aAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA3GZ;AA4GY;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA1GhB;AA2GgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAzGpB;AA2GgB;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAzGpB;AA4GY;EACI,WAAA;EACA,cAAA;AA1GhB;;AAoHQ;EACI,iBAAA;EACA,mBAAA;AAjHZ;;AAsHA;;EAEI,cAAA;EACA,qBAAA;AAnHJ","sourcesContent":["// Agent Bubble\n.agent-bubble-comp{\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    padding: 0px 16px;\n    margin: 12px 0 8px 0px;\n    &.if-animation-bubble{\n        animation-name: bubbleAnim;\n        animation-duration: 1s;\n        animation-fill-mode: forwards;\n        opacity: 0;\n    }\n    .agent-bubble-content{\n        display: flex;\n        flex-wrap: wrap;\n        flex-direction: column;\n        justify-content: flex-end;\n        align-items: flex-end;\n        max-width: 100%;\n        padding-left: 10%;\n        transition: 0.5s all ease;\n        word-break: break-word;\n        &:hover{\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    background-color: var(--agent-bubble-msg-bg-hover);\n                }                \n            }            \n        }\n        &.if-agent-img{\n            padding-right: 32px;\n            .bubble-msg-with-img{\n                .agent-img{\n                    display: block;\n                }\n            }\n        }       \n        &.small_text{\n            .top-info {\n                .time-stamp{\n                    font-size: 10px;\n                    line-height: 12px;\n                    time{\n                        font-size: 10px;\n                    }\n                }\n                .you-text{\n                    font-size: 10px;\n                    line-height: 12px;\n                }\n            }\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    font-size: 12px;\n                    line-height: 15px;\n                }\n            } \n            .bottom-info {\n                .time-stamp{\n                    font-size: 10px;\n                    line-height: 12px;\n                    time{\n                        font-size: 10px;\n                    }\n                }\n                .you-text{\n                    font-size: 10px;\n                    line-height: 12px;\n                }\n                .read-text{\n                    font-size: 10px;\n                    line-height: 12px;\n                }\n            }          \n        }\n        &.large_text{\n            .top-info {\n                .time-stamp{\n                    font-size: 14px;\n                    line-height: 17px;\n                    time{\n                        font-size: 14px;\n                    }\n                }\n                .you-text{\n                    font-size: 14px;\n                    line-height: 17px;\n                }\n            }\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    font-size: 16px;\n                    line-height: 19px;\n                }\n            }   \n            .bottom-info {\n                .time-stamp{\n                    font-size: 14px;\n                    line-height: 17px;\n                    time{\n                        font-size: 14px;\n                    }\n                }\n                .you-text{\n                    font-size: 10px;\n                    line-height: 12px;\n                }\n                .read-text{\n                    font-size: 14px;\n                    line-height: 17px;\n                }\n            }           \n        }\n        &.chat-bubble-style-1{\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    border-radius: 16px;\n                }\n            }\n        } \n        &.chat-bubble-style-2{\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    border-radius: 8px 2px 8px 8px;\n                }\n            }\n        }\n        &.hover-show-copy{  \n            &:hover{\n                .bubble-msg-with-img{\n                    .copy-bubble{\n                        display: block;\n                    }\n                }\n            }          \n        }\n        &.time-stamp-show-hover{\n            .top-info {\n                .time-stamp{\n                    display: none;\n                }\n            }\n            .bottom-info{\n                .time-stamp{\n                    display: none;\n                }\n            }\n            &:hover{\n                .top-info {\n                    .time-stamp{\n                        display: block;\n                    }\n                }\n                .bottom-info {\n                    .time-stamp{\n                        display: block;\n                    }\n                }\n            } \n        }\n        .top-info{\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            .time-stamp{\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--time-stamp-color);    // var(--agent-bubble-text-color);\n                time{\n                    font-size: 12px;\n                }\n            }\n            .you-text{\n                font-weight: 600;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--name-color);    // var(--agent-bubble-text-color);\n            }\n            .copied-text{\n                @extend .you-text;\n            }\n        }\n        .bubble-msg-with-img{\n            display: flex;\n            align-items: flex-end;\n            flex-direction: column;\n            flex-wrap: wrap;\n            justify-content: center;\n            margin: 2px 0;\n            position: relative;\n            .bubble-msg{\n                background:var(--agent-bubble-msg-bg);\n                border-radius: 8px 8px 2px 8px;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 17px;\n                color: var(--agent-bubble-msg-color);\n                padding: 8px 12px;\n                margin: 2px 0;\n            }\n            .copy-bubble{\n                position: absolute;\n                left: -24px;\n                top: auto;\n                z-index: 1;\n                cursor: pointer;\n                font-size: 14px;\n                display: none;\n                svg{\n                    path{\n                        fill: var(--sdk-gloabl-text-color);\n                    }\n                }\n            }\n            .agent-img{\n                position: absolute;\n                right: -32px;\n                bottom: 0;\n                width: 24px;\n                height: 24px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                display: none;\n                figure{\n                    line-height: normal;\n                    width: 100%;\n                    height: 100%;\n                    img{\n                        border: 1.5px solid var(--agent-bubble-img-border);\n                        border-radius: 100px;\n                        width: 100%;\n                        height: 100%;\n                    }\n                }\n            }\n        }\n        .bottom-info{\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            .time-stamp{\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--time-stamp-color); // var(--sdk-gloabl-text-color);\n                time{\n                    font-size: 12px;\n                }\n            }\n            .you-text{\n                font-weight: 600;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--name-color); // var(--sdk-gloabl-text-color);\n            }\n            .read-text{\n                font-weight: 500;\n                font-size: 11px;\n                line-height: 13px;\n                color: var(--sdk-gloabl-text-color);\n                display: flex;\n                align-items: center;\n                i{\n                    color: var(--agent-bubble-read-status-icon-color);\n                    font-size: 10px;\n                    margin-left: 5px;\n                }\n                &.hide{\n                    display: none;\n                }\n            }\n            .errorMsg{\n                display: flex;\n                align-items: center;\n                gap: 4px;\n                font-size: 11px;\n                font-weight: 500;\n                .failed-text{\n                    color: var(--destructive-500-main, #EF4444);\n                }\n                .retry-text, .delete-text{\n                   background: transparent;\n                   border: 0;\n                   cursor: pointer;\n                   padding: 0;\n                   color: var(--sdk-global-theme-color);\n                }\n                .or-text{\n                    opacity: 0.5;\n                    color: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n    }\n}\n\n// Agent Bubble\n.bot-bubble-comp{\n    display: flex;\n    width: 100%;\n    justify-content: flex-start;\n    padding: 0px 16px;\n    margin: 12px 0 8px 0;\n    &.if-animation-bubble{\n        animation-name: bubbleAnim;\n        animation-duration: 1s;\n        animation-fill-mode: forwards;\n        opacity: 0;\n    }\n    .bot-bubble-content{\n        display: flex;\n        flex-wrap: wrap;\n        flex-direction: column;\n        max-width: 100%;\n        padding-left: 32px;\n        justify-content: flex-start;\n        align-items: flex-start;\n        padding-right: 10%;\n        padding-left: 32px;\n        transition: 0.5s all ease;  \n        word-break: break-word;\n        &:hover{\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    background-color: var(--bot-bubble-msg-bg-hover);\n                }                \n            }\n        }\n        &.small_text{\n            .top-info {\n                .time-stamp{\n                    font-size: 10px;\n                    line-height: 12px;\n                    time{\n                        font-size: 10px;\n                    }\n                }\n                .you-text{\n                    font-size: 10px;\n                    line-height: 12px;\n                }\n            }\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    font-size: 12px;\n                    line-height: 15px;\n                }\n            } \n            .bottom-info {\n                .time-stamp{\n                    font-size: 10px;\n                    line-height: 12px;\n                    time{\n                        font-size: 10px;\n                    }\n                }\n                .you-text{\n                    font-size: 10px;\n                    line-height: 12px;\n                }\n                .read-text{\n                    font-size: 10px;\n                    line-height: 12px;\n                }\n            }          \n        }\n        &.large_text{\n            .top-info {\n                .time-stamp{\n                    font-size: 14px;\n                    line-height: 17px;\n                    time{\n                        font-size: 14px;\n                    }\n                }\n                .you-text{\n                    font-size: 14px;\n                    line-height: 17px;\n                }\n            }\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    font-size: 16px;\n                    line-height: 19px;\n                }\n            }   \n            .bottom-info {\n                .time-stamp{\n                    font-size: 14px;\n                    line-height: 17px;\n                    time{\n                        font-size: 14px;\n                    }\n                }\n                .you-text{\n                    font-size: 10px;\n                    line-height: 12px;\n                }\n                .read-text{\n                    font-size: 14px;\n                    line-height: 17px;\n                }\n            }           \n        }\n        &.chat-bubble-style-1{\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    border-radius: 16px;\n                }\n            }\n        } \n        &.chat-bubble-style-2{\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    border-radius: 2px 8px 8px 8px;\n                }\n            }\n        }\n        &.hover-show-copy{  \n            &:hover{\n                .bubble-msg-with-img{\n                    .copy-bubble{\n                        display: block;\n                    }\n                }\n            }          \n        }\n        &.time-stamp-show-hover{\n            .top-info {\n                .time-stamp{\n                    display: none;\n                }\n            }\n            .bottom-info{\n                .time-stamp{\n                    display: none;\n                }\n            }\n            &:hover{\n                .top-info {\n                    .time-stamp{\n                        display: block;\n                    }\n                }\n                .bottom-info {\n                    .time-stamp{\n                        display: block;\n                    }\n                }\n            } \n        }\n        .top-info{\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            width: 100%;\n            .time-stamp{\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--time-stamp-color); // var(--sdk-gloabl-text-color);\n                flex-shrink: 0;\n                time{\n                    font-size: 12px;\n                }\n            }\n            .you-text{\n                font-weight: 600;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--name-color); // var(--sdk-gloabl-text-color);\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n            }\n            .copied-text{\n                @extend .you-text;\n            }\n        }\n        .bubble-msg-with-img{\n            display: flex;\n            align-items: flex-start;\n            margin: 4px 0;\n            position: relative;\n            flex-direction: column;\n            justify-content: center;\n            flex-wrap: wrap;\n            .bubble-msg{\n                background: var(--bot-bubble-msg-bg);\n                border-radius: 8px 8px 8px 2px;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 17px;\n                color: var(--bot-bubble-msg-color);\n                padding: 8px 12px;\n                margin: 2px 0;\n                word-break: break-word;\n                white-space: break-spaces;\n                img {\n                    width: 100%;\n                }\n                p.indent {\n\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t}\n                .isLink {\n                    a {\n                        color: var(--sdk-global-theme-color);\n                    }\n                }\n            }\n            .copy-bubble{\n                position: absolute;\n                right: -24px;\n                top: auto;\n                z-index: 1;\n                cursor: pointer;\n                font-size: 14px;\n                display: none;\n                svg{\n                    path{\n                        fill: var(--sdk-gloabl-text-color);\n                    }\n                }\n            }\n            .bot-img{\n                position: absolute;\n                right: auto;\n                left: -32px;\n                top: 0;\n                bottom: auto;\n                width: 24px;\n                height: 24px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                figure{\n                    line-height: normal;\n                    width: 100%;\n                    height: 100%;\n                    img{\n                        border: 1.5px solid var(--bot-bubble-img-border);\n                        border-radius: 100px;\n                        width: 100%;\n                        height: 100%;\n                    }\n                }\n            }\n        }\n        .bottom-info{\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            width: 100%;\n            .time-stamp{\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 15px;\n                color:  var(--time-stamp-color); // var(--sdk-gloabl-text-color);\n                flex-shrink: 0;\n                time{\n                    font-size: 12px;\n                }\n            }\n            .you-text{\n                font-weight: 600;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--name-color); // var(--sdk-gloabl-text-color);\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n            }\n            .read-text{\n                font-weight: 500;\n                font-size: 11px;\n                line-height: 13px;\n                color: var(--sdk-gloabl-text-color);\n                flex-shrink: 0;\n            }\n        }\n    }\n}\n\n\n.attachment-sended-temp-wrapper{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 0 16px 5px 16px;\n    .multiple-attchments{\n        border-radius: 4px;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        background: var(--sdk-global-white-bg);\n        padding: 8px;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        // max-width: 285px;\n        max-width: 100%;\n        .attchments-wrap{\n            display: flex;\n            gap: 4px;\n            align-items: flex-start;\n            position: relative;\n            .img-attch{\n                width: 100%;\n                height: 100%;\n                figure{\n                    line-height: 0;\n                    width: 100%;\n                    height: 100%;\n                    img{\n                        width: 100%;\n                        height: 100%;\n                        object-fit: cover;\n                        border-radius: 4px;\n                    }\n                }\n            }\n            .layer-multiple{\n                position: absolute;\n                border-radius: 4px;\n                background: rgba(0, 0, 0, 0.4);\n                width: 132px;\n                height: 100px;\n                right: 0;\n                top: 0;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: var(--sdk-global-white);\n                font-size: 14px;\n                font-weight: 700;\n                line-height: normal;\n                cursor: pointer;\n                z-index: 2;\n                border: 0;\n            }\n        }\n        .attchment-details{\n            display: flex;\n            padding: 8px;\n            align-items: flex-start;\n            gap: 10px;\n            align-self: stretch;\n            .content-info{\n                width: 100%;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                h2{\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 14px;\n                    font-weight: 600;\n                    line-height: normal;\n                    overflow: hidden;\n                    white-space: nowrap;\n                    text-overflow: ellipsis;\n                }\n                p{\n                    color: var(--sdk-gloabl-text-color);\n                    font-size: 12px;\n                    font-weight: 400;\n                    line-height: normal;\n                    margin-top: 4px;\n                }\n            }\n            .kr-button-blue-light{\n                width: auto;\n                flex-shrink: 0;\n            }\n        }\n    }\n}\n\n\n[dir=\"rtl\"]{\n    .bot-bubble-comp{\n        // justify-content: flex-end;\n        .bot-bubble-content{\n            padding-left: 10%;\n            padding-right: 32px;\n        }\n    }\n}\n\n.bot-bubble-comp .time-stamp,\n.agent-bubble-comp .time-stamp {\n    direction: ltr;\n    unicode-bidi: isolate;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
